import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import Colors from '../../utils/colors';

const CustomLoader = ({ size = 'default', fullscreen = false }) => {
  const antIcon = (
    <LoadingOutlined 
      style={{ 
        fontSize: size === 'small' ? 14 : fullscreen ? 24 : 16, 
        color: Colors.primary 
      }} 
      spin 
    />
  );

  if (fullscreen) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      }}>
        <Spin 
          size="large" 
          className="white-spinner"
        />
      </div>
    );
  }

  return <Spin indicator={antIcon} />;
};

export default CustomLoader;